import React from "react";
import "./SkillsSection.css";
import { FaGlobe, FaMobileAlt, FaBug, FaServer } from "react-icons/fa";
import { useState, useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { useTranslation } from "../i18n";

// Datos de habilidades actualizados con más herramientas en Testing y DevOps
const skillsData = [
    { 
        icon: <FaGlobe size={46} color="#5f7868" />, 
        title: "Web", 
        skills: "React | JavaScript | Vue.js | Node.js | MongoDB | MySQL | Express | HTML | CSS | React Testing Library | Mocha"
    },
    { 
        icon: <FaMobileAlt size={46} color="#5f7868" />, 
        title: "Mobile", 
        skills: "React Native | Kotlin | Swift | Android Studio | Xcode | Flutter | UIAutomator2 | Espresso | WebDriverIO"
    },
    { 
        icon: <FaBug size={46} color="#5f7868" />, 
        title: "Testing", 
        skills: "Selenium | Cypress | Playwright | Appium | Jest | Robot Framework | Cucumber | PyTest | TestNG | Postman | Gatling"
    },
    { 
        icon: <FaServer size={46} color="#5f7868" />, 
        title: "DevOps", 
        skills: "Docker | Kubernetes | AWS | Azure | CI/CD | Jenkins | GitHub Actions | Terraform | Ansible | Prometheus | Grafana | New Relic"
    }
];

function SkillsSection() {
    const { t, language } = useTranslation();
    const [isMobile, setIsMobile] = useState(false);
    const progressCircle = useRef(null);
    const progressContent = useRef(null);
    const onAutoplayTimeLeft = (s, time, progress) => {
        if (progressCircle.current && progressContent.current) {
            progressCircle.current.style.setProperty('--progress', 1 - progress);
            progressContent.current.textContent = `${Math.ceil(time / 1000)}s`;
        }
    };
        
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkMobile(); // Verifica al cargar

        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    const skillsKicker = {
        es: "Habilidades",
        en: "Skills",
        de: "Fahigkeiten",
    };

    return (
        <section className="skills-container">
            <div className="skills-heading">
                <span className="about-section-kicker">{skillsKicker[language] || skillsKicker.es}</span>
                <h2 className="skills-label section-title-academy">{t("about.skillsTitle")}</h2>
            </div>
            <p className="skills-info">
                {t("about.skillsInfo")}
            </p>
            <>
                {isMobile ? (
                    <Swiper
                        modules={[Pagination, Autoplay]}
                        spaceBetween={20}
                        slidesPerView={1}
                        pagination={{ clickable: true }}
                        autoplay={{ delay: 3000, disableOnInteraction: false }} // 🔥 Autoplay cada 3 segundos
                        loop={true} // 🔥 Hace que los slides se repitan en un bucle
                        style={{ width: "100%", maxWidth: "1200px", height: "auto" }}
                        onAutoplayTimeLeft={onAutoplayTimeLeft}
                        className="skills-swiper"
                    >
                        {skillsData.map((skill, index) => (
                            <SwiperSlide key={index}>
                                <div className="skill-card">
                                <div className="skill-icon">{skill.icon}</div>
                                <h3 className="skill-title">{skill.title}</h3>
                                <p className="skill-list">{skill.skills}</p>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                ) : (
                    <div className="skill-boxes">
                        {skillsData.map((skill, index) => (
                            <div key={index} className="skill-card">
                                <div className="skill-icon">{skill.icon}</div>
                                <h3 className="skill-title">{skill.title}</h3>
                                <p className="skill-list">{skill.skills}</p>
                            </div>
                        ))}
                    </div>
                )}
            </>
        </section>
    );
}

export default SkillsSection;
